import { useTranslation } from '@exam-room/translations';

import {
  AddOutlinedIcon,
  Header,
  IconButton,
  LanguageSwitchMenu,
  RemoveOutlinedIcon,
  Tooltip,
} from '../../../../components';
import { useFontSize } from '../../../exam/contexts/FontSizeContext';

export default function ExamEventPreviewHeader() {
  const { t, i18n } = useTranslation();
  const { language, changeLanguage } = i18n;
  const { increaseFontSize, decreaseFontSize, fontScale } = useFontSize();

  return (
    <Header
      left={<img src='/logo.svg' alt='logo' className='h-10' />}
      middle={null}
      right={
        <div key='font-size-adjust' className='flex items-center gap-1'>
          <Tooltip
            content={t('header.fontSizeDecrease')}
            position='bl'
            className='z-50 font-semibold'
          >
            <IconButton onClick={decreaseFontSize} disabled={fontScale === -1}>
              <RemoveOutlinedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip content={t('header.fontSize')} position='bl' className='z-50 font-semibold'>
            <div className='text-body1 bg-grey-100 grid size-10 place-items-center rounded-sm px-3 py-2 font-semibold'>
              A
            </div>
          </Tooltip>
          <Tooltip
            content={t('header.fontSizeIncrease')}
            position='bl'
            className='z-50 font-semibold'
          >
            <IconButton onClick={increaseFontSize} disabled={fontScale === 1}>
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip>
          <LanguageSwitchMenu
            key='language-switch-menu'
            currentLanguage={language.toUpperCase()}
            onSwitchToEnglish={() => {
              changeLanguage('en');
            }}
            onSwitchToThai={() => {
              changeLanguage('th');
            }}
          />
        </div>
      }
    />
  );
}
